import * as React from "react";
const SvgFiRrShishKebab = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shish-kebab_svg__a)">
      <path
        fill="#062147"
        d="M22.277.709c-1.342-.94-3.215-.94-4.555 0a4 4 0 0 0-1.535 4.5 1.58 1.58 0 0 1-.407 1.596l-1.923 1.923-.637-.637a3.73 3.73 0 0 0-5.27 0 3.7 3.7 0 0 0-1.074 2.814c-1.015-.038-2.043.302-2.784 1.043A3.7 3.7 0 0 0 3 14.584a3.7 3.7 0 0 0 1.092 2.635l.637.637-4.436 4.437a.999.999 0 1 0 1.414 1.414l4.436-4.436.637.637a3.72 3.72 0 0 0 2.636 1.09 3.704 3.704 0 0 0 3.712-3.869c.05.002.095.014.145.014.995 0 1.932-.388 2.636-1.092a3.7 3.7 0 0 0 1.092-2.636 3.7 3.7 0 0 0-1.092-2.635l-.637-.637 1.923-1.923a3.57 3.57 0 0 0 .9-3.614 2.01 2.01 0 0 1 .776-2.26 2.03 2.03 0 0 1 2.258 0c.554.39.871.993.871 1.655 0 .252-.073.66-.707 1.292a1 1 0 1 0 1.414 1.415C23.577 5.838 24 4.953 24 4A3.98 3.98 0 0 0 22.277.709m-11.64 17.785a1.73 1.73 0 0 1-2.443 0l-2.688-2.688A1.72 1.72 0 0 1 5 14.585c0-.461.18-.896.506-1.222s.76-.506 1.222-.506.895.18 1.221.506l2.69 2.688a1.73 1.73 0 0 1-.002 2.443m3.856-3.857c-.652.65-1.79.653-2.442 0l-2.689-2.688A1.725 1.725 0 0 1 10.584 9c.443 0 .885.168 1.222.505l2.688 2.688c.326.326.506.76.506 1.22 0 .462-.18.897-.506 1.223"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shish-kebab_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShishKebab;
